module.exports = __webpack_public_path__ + "img/star_white_128x128.13db92d2.png";